import { Contact } from "../components/Contact";

export const ContactPage = () => {
  return <Contact />;
};
